import {Comparator} from "./comparator.interface";
import {Entity} from "../domain/entities/entity";
import {injectable} from "tsyringe";
import {comparator} from "../decorators/comparator.decorator";

// @ts-ignore
@comparator(Entity)
@injectable()
export class EntityComparator implements Comparator<Entity> {

    isEqualTo(value1: Entity | null, value2: Entity | null): boolean {
        if ([value1, value2].includes(null)) {
            return value1 === value2; // because one of them is null -> equality only if second one too
        }

        return value1!.uid === value2!.uid;
    }

}